<template>
  
</template>

<script setup>

import { Preferences } from '@capacitor/preferences';

  import { computed } from "@vue/reactivity"
  import { ref , watch } from 'vue'

  // https://stackoverflow.com/questions/64117116/how-can-i-use-async-await-in-the-vue-3-0-setup-function-using-typescript

  const emit = defineEmits(['return-value'])
 
  const props = defineProps({
      action : Object,
      trigger : Number
    })

  // processRequest("get","name","")
  
  const trigger = computed({ get() { return props.trigger } })

  watch (trigger, () => {
      //console.log("trigger set",props.action)
      processRequest(props.action.action,props.action.key,props.action.value)
  })

  async function processRequest(action,key,stringValue) {
    //console.log("inside process request",action,key,stringValue)
    //console.log("inside process request",action,key)
    switch (action) {
      case "set" :
        await Preferences.set({
          key: key,
          value: stringValue,
        });
        //console.log("after set ",key)
        emit('return-value',props.action.action,props.action.key,"")
        break
      case "get" :
        const { value } = await Preferences.get({ key: key });
        //console.log(`Hello ${value}!`);
        emit('return-value',props.action.action,props.action.key,value )
        break
      }
  };

</script>

<style scoped>
</style>
